import script from "./OrderDetailDTC.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderDetailDTC.vue?vue&type=script&setup=true&lang=ts"

import "./OrderDetailDTC.vue?vue&type=style&index=0&id=571cb466&scoped=true&lang=scss"

import exportComponent from "/opt/jenkins/workspace/Application deploy/prod-fe-cn-social-media-wph-h5-deployment/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-571cb466"]])

export default __exports__